module.exports = __webpack_public_path__ + "static/media/collage.eaef1ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/collage.jpg
// module id = 2251
// module chunks = 0